import { FiArrowDownCircle } from "react-icons/fi"

export const TitleFooter = ({ title }) => {
    return (<p className="flex gap-2 items-center 2xl:text-2xl text-md font-bold text-slate-50">{title}<span className="text-md"><FiArrowDownCircle /></span></p>)
}